import {debug} from "../../utils";

export const ACTION_INVENTORY_CHANGED = "ACTION_INVENTORY_CHANGED";
// export const ACTION_SCAN_CHANGED_GET_ALL_SCANS = "ACTION_SCAN_CHANGED_GET_ALL_SCANS";
//export const ACTION_SCAN_LIST_CHANGED = "ACTION_SCANLIST_CHANGED";

export function InventoryPageReducer(state = {}, action) {
    switch (action.type) {
        case ACTION_INVENTORY_CHANGED: {
            debug(`ReportsPageReducer ${ACTION_INVENTORY_CHANGED} is being processed...`)
            return {...state, ...action.payload};
        }
        // case ACTION_SCAN_CHANGED_GET_ALL_SCANS: {
        //     return { ...state, ...action.payload };
        // }
        // case ACTION_SCAN_LIST_CHANGED: {
        //     return { ...state, ...action.payload };
        // }
        default:
            return state;
    }
}